import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { BehaviorSubject, ReplaySubject, Subscription } from 'rxjs';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { FiltersService } from 'src/app/core/services/filters/filters.service';
import { OrderStatus } from 'src/app/models/enums/order-status.enum';
import { Order } from 'src/app/models/interfaces/order';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AlertBoxComponent } from 'src/app/shared/components/alert-box/alert-box.component';
import { FilterUtilService } from 'src/app/core/services/uitls/filter-utilizer/filter-util.service';
import { ConfirmationBoxComponent } from 'src/app/shared/components/confirmation-box/confirmation-box.component';
import { AdminOrdersService } from '../../services/orders/admin-orders.service';
import { ColumnsUtilService } from 'src/app/core/services/uitls/columns-util/columns-util.service';
import { handlePaginationChangeUtil } from 'src/app/core/services/uitls/navigation.utils';
import { ProjectsService } from 'src/app/features/projects/services/projects.service';

@Component({
  selector: 'app-orders-list',
  templateUrl: './orders-list.component.html',
  styleUrls: ['./orders-list.component.scss'],
})
export class OrdersListComponent implements OnInit {
  orders: Order[] = [];
  orderType: any;
  orderStatus: any = OrderStatus;
  searchValue: string;
  totalRecords: number = 0;
  page: number = 1;
  page_size: number = 20;
  config: any;
  selectedRowsIndex: any[] = [];
  selectedRowsPK: any[] = [];
  deletedOrderID: any[] = [];
  deletedOrderIndex: any[] = [];
  modelImg: boolean;
  imgPath: string;
  confirmMsg: string;
  disabledDelete: boolean = true;
  filterData;
  imgDefault: string = '/assets/images/svg/sort-default.svg';
  imgASC: string = '/assets/images/svg/sort-up.svg';
  imgDesc: string = '/assets/images/svg/sort-down.svg';
  filterDataInit = {};
  filterParamsUrl: Record<string, string | string[]> = {};
  name: string;
  assignedInspectorId: any;
  spinner: boolean = true;
  filterPage: string = 'ORDERS';
  gridIdentifier: string = 'INDIVIDUAL_ORDERS';
  pageTitle: string = 'الطلبات';
  saveDialogRef: MatDialogRef<AlertBoxComponent>;
  deleteDialogRef: MatDialogRef<ConfirmationBoxComponent>;
  savedFilters: any = [];
  spinnerKey: string = 'spinner';
  tableHeaderData = [];
  updatedOrders = new BehaviorSubject({});
  orderData = this.updatedOrders.asObservable();
  destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);
  isTotalRowsSelected: boolean = false;
  currentItemsPerPage: number;
  selectedQuery: any = {};
  @ViewChild('goUp', { static: true }) contentPage: ElementRef;
  is_sopra: boolean = false;
  private ordersSub?: Subscription;

  constructor(
    private router: Router,
    private adminOrder: AdminOrdersService,
    private titleService: Title,
    private route: ActivatedRoute,
    private filter: FiltersService,
    private filterUtil: FilterUtilService,
    private columnsUtil: ColumnsUtilService,
    private matDialog: MatDialog,
    private gridService: ProjectsService,
  ) {
    this.config = {
      id: 'myPagination',
      itemsPerPage: this.page_size,
      currentPage: this.page,
      totalItems: this.totalRecords,
    };
  }

  ngOnInit() {
    this.is_sopra = this.route.snapshot.params.sopra == 'sopra';
    this.pageTitle = this.is_sopra ? 'طلبات سوبرا' : 'الطلبات';
    this.route.queryParams.subscribe((params) => {
      if (params.page && params.page_size) {
        this.page = Number(params.page);
        this.page_size = Number(params.page_size);
        this.config.currentPage = Number(params.page);
        this.config.itemsPerPage = Number(params.page_size);
      } else {
        this.router.navigate([], {
          queryParams: { page: 1, page_size: 20 },
          queryParamsHandling: 'merge',
        });
      }

      this.filterUtil.clearfilterParams(this.filterParamsUrl);
      this.filterUtil.clearfilterParams(this.filterDataInit);
      if (Object.keys(params).length > 0) {
        if (params['query']) {
          this.searchValue = params['query'] ? params['query'] : '';
        }
        const customParams = { ...params };
        const { query, ...restparams } = customParams;
        this.filterParamsUrl = { ...restparams };
        this.filterDataInit = { ...restparams };
      }
    });
    this.getTableHeaderData({ filter_page: this.gridIdentifier });
    this.getOrdersFilter();
    this.titleService.setTitle(' الطلبات | عاين');
    this.filterUtil.getSavedFilters(this, this.filterPage);
    this.filter.changeSelectedFilter(this.filterDataInit);
    this.applyColumnsData();
    this.filterUtil.applySelectedFilter(
      this,
      this.getOrdersByPage,
      this.spinnerKey,
    );
  }

  getTableHeaderData(param) {
    this.gridService.getTableHeaderData(param).subscribe((data) => {
      this.tableHeaderData = data;
      this.columnsUtil.applyColumnsData(this.tableHeaderData);
    });
  }

  applyColumnsData() {
    let tabelHeaderDataTemp = [...this.tableHeaderData];
    if (this.is_sopra) {
      const index = tabelHeaderDataTemp.findIndex(
        (item) => item.value === 'order_inspector',
      );
      if (index !== -1) {
        tabelHeaderDataTemp.splice(index + 1, 0, {
          value: 'inspector_share_type',
          display_name: 'نوع حصة الفاحص',
          sortable: false,
          visible: true,
        });
      }
    }
    this.columnsUtil.applyColumnsData(tabelHeaderDataTemp);
  }

  quickSearch(event) {
    this.searchValue = event;
    this.spinner = true;
    this.config.currentPage = 1;
    this.config.itemsPerPage = 20;
    this.getOrdersByPage();
  }

  getOrdersByPage() {
    this.emptySelectedRows();
    this.isTotalRowsSelected = false;
    const params: Record<string, string | string[] | number | boolean> = { ...this.filterParamsUrl };

    if (this.searchValue) {
      params['query'] = this.searchValue;
    } else if ('query' in params) {
      delete params['query'];
    }

    params['page'] = this.config.currentPage;
    params['page_size'] = this.config.itemsPerPage;
    params['is_exsep_order'] = this.is_sopra;
    this.ordersSub = this.adminOrder.getAdminOrdersByPage(params).subscribe(
      (data) => {
        this.loadOrders(data);
        this.updatedOrders.next(data.results);
      },
      (error) => {
        this.handleBackendError(error);
      },
    );
  }

  loadOrders(data) {
    this.spinner = false;
    this.orders = data.results;
    this.config['totalItems'] = data.count;
    this.currentItemsPerPage = data.results.length;
    const params = { ...this.filterParamsUrl, query: this.searchValue };
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: params,
      queryParamsHandling: '',
    });
  }

  getOrdersFilter() {
    let params = {
      filter_page: this.filterPage,
      ... (this.is_sopra ? { is_exsep_order: true } : {})
    };
   
    this.filter.getFiltersData(params).subscribe(
      (data) => {
        this.filterData = data;
      },
      (error) => {
        this.handleBackendError(error);
      },
    );
  }

  handleBackendError(error) {
    try {
      console.log(error);
    } catch {
      console.log(error);
    }
  }

  getSelectedRow(event) {
    this.selectedRowsIndex = event.index;
    this.selectedRowsPK = event.id;
    this.isTotalRowsSelected = false;
  }

  deleteSelectedRows() {
    this.deletedOrderID = this.selectedRowsPK;
    this.deletedOrderIndex = this.selectedRowsIndex;
    this.showDeleteConfirmationBox();
  }

  showDeleteConfirmationBox() {
    this.deleteDialogRef = this.matDialog.open(ConfirmationBoxComponent, {
      data: {
        id: this.deletedOrderID,
        index: this.deletedOrderIndex,
        message: 'هل أنت متأكد من حذف الطلب',
      },
    });
    this.deleteDialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.delete(result);
      }
    });
  }

  selectTotalRows(event) {
    this.isTotalRowsSelected = event;
    this.selectedQuery = { ...this.filterParamsUrl };
    if (this.searchValue) {
      this.selectedQuery['query'] = this.searchValue;
    }
  }

  emptySelectedRows() {
    this.selectedRowsIndex.splice(0, this.selectedRowsIndex.length);
    this.selectedRowsPK.splice(0, this.selectedRowsPK.length);
  }

  delete(event) {
    let index = event.index;
    let pk = event.id;
    this.adminOrder.deleteAdminOrder(pk).subscribe(
      (data) => {
        for (let i = index.length - 1; i >= 0; i--) {
          let OrderInd = index[i];
          this.orders.splice(OrderInd, 1);
        }
        this.emptySelectedRows();
      },
      (error) => {
        try {
          this.modelImg = false;
          this.imgPath = '../../../../assets/images/svg/refusal-icon-admin.svg';
          this.confirmMsg = '  عذراً لا يمكن حذف الطلب . ‎';
          this.showAlertBox();
          this.emptySelectedRows();
        } catch {}
      },
    );
  }

  showAlertBox() {
    this.saveDialogRef = this.matDialog.open(AlertBoxComponent, {
      data: {
        imgSuccess: this.modelImg,
        message: this.confirmMsg,
        imgPath: this.imgPath,
        button: 'تم',
      },
    });
  }

  openOrder(id, newTab?) {
    if (newTab) {
      const url = this.router.serializeUrl(
        this.router.createUrlTree([`/pages/orders/${id}`]),
      );
      window.open(url, '_blank');
    } else {
      this.router.navigateByUrl('/pages/orders/' + id);
    }
  }

  changeToSpecific(event) {
    this.pageChanged(event);
  }

  pageChanged(event) {
    handlePaginationChangeUtil(
      this.contentPage,
      (value: boolean) => (this.spinner = value),
      this.router,
      'page',
      event,
    );
    this.config.currentPage = event;
    this.isTotalRowsSelected = false;
    this.getOrdersByPage();
  }
  pageSizeChanged(event) {
    handlePaginationChangeUtil(
      this.contentPage,
      (value: boolean) => (this.spinner = value),
      this.router,
      'page_size',
      event,
    );
    this.config.itemsPerPage = event;
    this.getOrdersByPage();
  }
  onFilterTextBoxChanged() {
    this.config.currentPage = 1;
    this.config.itemsPerPage = 20;
    this.getOrdersByPage();
  }

  filterFormValues(event) {
    this.filterParamsUrl = event.filterParamsUrl;
    this.spinner = true;
    this.config.currentPage = 1;
    this.config.itemsPerPage = 20;
    this.getOrdersByPage();
  }

  toggleSorting(event) {
    this.spinner = true;
    if (event.col?.length) {
      this.filterParamsUrl['ordering'] = event.col;
    } else {
      delete this.filterParamsUrl['ordering'];
    }
    this.getOrdersByPage();
  }

  disabledDeleteBtn(event) {
    this.disabledDelete = event;
  }

  sipnnerState(state) {
    this.spinner = state;
  }

  updateOrderStatus(event) {
    if (event.done) {
      this.confirmMsg = 'تم تغير حالة الطلبات بنجاح ';
      this.modelImg = true;
      this.showAlertBox();
      this.config.currentPage = 1;
      this.config.itemsPerPage = 20;
      this.getOrdersByPage();
    } else {
      this.modelImg = false;
      this.confirmMsg = event.error;
      this.showAlertBox();
    }
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
    this.filter.changeSelectedFilter({});
    this.ordersSub.unsubscribe();
  }
}
